var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.logoType},[_c('div',{class:_vm.$style.logoTag},[_vm._v("shop on campus"),_c('span',{class:_vm.$style.tm},[_vm._v("™")])]),_c('div',{class:_vm.$style.logoMark},[_vm._v(_vm._s(_vm.siteName))])])}
var staticRenderFns = []

export { render, staticRenderFns }